import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { PingApi } from "@freightsimple/generated-dashboard-openapi-client/apis/PingApi";
import { getConfig } from "@/Apis/getConfig";

export function usePingApi(): PingApi {
  return new PingApi(new Configuration({ ...getConfig() }));
}
